export const cardContent = (theme) => ({
    padding: 3,
    backgroundColor: theme.palette.mode === "light" ? "rgba(255, 255, 255, 0.5) !important" : "rgba(0, 0, 0, 0.1) !important", 
    color: theme.palette.mode === "light" ? "#000" : "#fff",
    borderRadius: 4,
    boxShadow: theme.palette.mode === "light" ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "0 4px 8px rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px) !important", 
    "@media (max-width: 600px)": {
      padding: 2,
    },
  });
  
  
  export const productName = {
    fontFamily: "'Space Grotesk', sans-serif",
    fontWeight: "bold",
    marginBottom: 2,
  };
  
  export const variantBox = {
    marginBottom: 3,
  };
  
  
  export const priceText = {
    fontFamily: "'Space Grotesk', sans-serif",
    fontSize: "16px",
    fontWeight: "bold",
  };
  
  export const button = (theme) => ({
    fontFamily: "'Space Grotesk', sans-serif",
    borderRadius: 2,
    padding: "8px 16px",
    fontSize: "14px",
    backgroundColor: theme.palette.mode === "light" ? "#fff" : "#333",
    color: theme.palette.mode === "light" ? "#000" : "#fff",
    borderColor: theme.palette.mode === "light" ? "#1976d2" : "#90caf9",
    marginBottom: 2,
    marginTop: 2,
    transition: "0.3s", 
    "&:hover": {
      backgroundColor: theme.palette.mode === "light" ? "#f5f5f5" : "#444",
      borderColor: theme.palette.mode === "light" ? "#1565c0" : "#64b5f6",
    },
    "&.active": {  
      backgroundColor: theme.palette.mode === "light" ? "#00f5ff" : "#006a8e", 
      color: "#fff",
      boxShadow: `0 0 10px #00f5ff, 0 0 20px #00f5ff`, 
    },
    "@media (max-width: 600px)": {
      padding: "5px 10px",
      fontSize: "12px",
    },
  });
  
  
  
  export const gridContainer = {
    marginBottom: 2,
  };
  
  export const gridItem = {
    display: "flex",
    alignItems: "center",
  };
  
  export const priceContainer = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  };